
<div class="dialog-header">
    <h2>Add KPI to Dashboard</h2>
    <ng-icon name="heroXMark" mat-dialog-close class="cursor-pointer"></ng-icon>

</div>
<form [formGroup]="kpiForm" (ngSubmit)="saveKpi()">

    <mat-dialog-content>
        <div style="padding-bottom: 10px;">
            <mat-form-field appearance="outline">
            <mat-label>KPI Name</mat-label>
            <input type="text" matInput autocomplete="off" formControlName="kpiName"  
              [errorStateMatcher]="matcher">
            <mat-error *ngIf="kpiForm.get('kpiName').hasError('required')">
              KPI Name is required
            </mat-error>
          </mat-form-field>
        </div>

        <div >
            <mat-form-field appearance="outline">
                <mat-label>count</mat-label>
                <input type="text" matInput autocomplete="off" formControlName="count" readonly
                [errorStateMatcher]="matcher">
              <!-- <mat-error *ngIf="KpiForm.get('count').hasError('required')">
                KPI Name is required
              </mat-error> -->
            </mat-form-field>
        </div>
    </mat-dialog-content>
    <mat-divider></mat-divider>
    <mat-dialog-actions align="end">
  
        <button color="accent" mat-raised-button class="ml-3" [disabled]="isLoading" type="submit">Add To DashBoard
            <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
        </button>
        <button mat-raised-button mat-dialog-close color="primary" mat-dialog-close
            class="outlined-btn">Cancel</button>
      
    </mat-dialog-actions>
</form>